var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeBankingAndPaymentsAdditionalFeatures(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-4644.000000, -1647.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home-banking-and-payments/Additional-features",
    transform: "translate(4644.000000, 1647.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.924,26.83 L15.424,28.33 L13.924,26.83 L9.924,22.83 C10.753,22.001 12.095,22.001 12.924,22.83 L15.424,25.33 L19.924,20.83 C20.753,20.001 22.095,20.001 22.924,20.83 L16.924,26.83 Z M11,10.559 C11,10.052 11,9.914 11.47,9.914 L12.462,9.914 L12.462,8.869 L12.462,8.853 L11.47,8.853 C11,8.853 11,8.731 11,8.243 L11,7.913 C11,7.406 11,7.268 11.47,7.268 L12.532,7.268 C12.689,5.821 13.106,4.934 13.978,4.237 C14.691,3.682 15.613,3.418 16.781,3.418 C17.861,3.418 18.957,3.75 19.776,4.203 C19.967,4.308 20.003,4.43 19.897,4.707 L19.41,5.718 C19.305,5.961 19.167,5.979 18.957,5.858 C18.4,5.526 17.582,5.23 16.728,5.23 C16.153,5.23 15.719,5.37 15.353,5.736 C15.022,6.067 14.865,6.555 14.778,7.268 L17.878,7.268 C18.348,7.268 18.348,7.406 18.348,7.913 L18.348,8.243 C18.348,8.731 18.348,8.853 17.878,8.853 L14.691,8.853 L14.691,9.914 L17.878,9.914 C18.348,9.914 18.348,10.052 18.348,10.559 L18.348,10.854 C18.348,11.341 18.348,11.465 17.878,11.465 L14.848,11.465 C14.935,11.953 15.092,12.301 15.3,12.544 C15.649,12.962 16.171,13.189 17.129,13.189 C17.842,13.189 18.591,13.015 19.184,12.771 C19.445,12.666 19.514,12.771 19.584,13.067 L19.776,13.902 C19.845,14.214 19.845,14.372 19.601,14.477 C18.905,14.789 17.791,15 16.989,15 C15.37,15 14.343,14.721 13.612,13.989 C13.037,13.432 12.706,12.63 12.549,11.465 L11.47,11.465 C11,11.465 11,11.341 11,10.854 L11,10.559 Z M25,0 L4,0 L4,29 C4,30.657 5.343,32 7,32 L28,32 L28,3 C28,1.344 26.657,0 25,0 L25,0 Z",
    id: 20
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeBankingAndPaymentsAdditionalFeatures);
export default __webpack_public_path__ + "static/media/home-banking-and-payments-additional-features.2381a006.svg";
export { ForwardRef as ReactComponent };